/* =============================================================================
   Night Operators PVS-31 PRO — static lander behaviour
   Vanilla JS. No dependencies. No framework.
   Scoped entirely inside #no-pvs31 — touches nothing else on the page.
   Safe to load with <script defer> or at the end of the product template.
   ========================================================================== */
(function () {
  "use strict";

  var ROOT_ID = "no-pvs31";
  var CDN = "https://nightoperators-pvs-31.lovable.app";

  /* ---------------------------------------------------------------- pricing */
  var BASE_PRICE = 3799.95;
  var HELMET_PRICE = 149.95;

  var FOM_UPCHARGE = {
    "1400-1550": 0,
    "1600-1800": 650,
    "1800-1950": 1150,
    "2000-2100": 1600
  };

  var FOM_COMPARE = {
    "1400-1550": 7599.0,
    "1600-1800": 10399.95,
    "1800-1950": 10599.95,
    "2000-2100": 10799.95
  };

  var FOM_EXPLAINER = {
    "1400-1550":
      "Mid-tier performance. Sharper edge-to-edge clarity. Recommended for most operators.",
    "1600-1800":
      "Upper mid-premium Gen 2+ tubes. Enhanced resolution and light gathering for serious operators.",
    "1800-1950":
      "Premium Gen 2+ tubes. Outstanding resolution and light gathering for serious nighttime work.",
    "2000-2100":
      "Top-tier Gen 2+ performance. Maximum resolution and light gathering for the most demanding operators."
  };

  var OUT_OF_STOCK = { "2000-2100": true };

  /* ------------------------------------------------------- Shopify variants */
  var KIT_VARIANTS = {
    "1400-1550": "50751937872118",
    "1600-1800": "50751937904886",
    "1800-1950": "51017700999414",
    "2000-2100": "50752033161462"
  };

  var HELMET_VARIANTS = {
    "BLK-M": "51760827728118",
    "BLK-L": "51760827760886"
  };

  /* ---------------------------------------------------------------------------
     HELMET SIZE AVAILABILITY (2026-09-19).
     A size that is sold out is never selectable. Availability is read once from
     the product .js endpoint. While the answer is unknown nothing is greyed, so
     a failed read can never hide a helmet we actually have.
     ------------------------------------------------------------------------ */
  /* round 4 (14 Oct 2026, Bon): we only sell the VENTED helmet now. COLOR-SIZE to variant id, read from the live
     helmet product, VENTED shell only, so a new vented colour or size shows up here by itself once it is in stock. */
  function noVented(p) {
    var out = {}; if (!p || !p.variants) return out;
    var names = (p.options || []).map(function (o) { return String(o && o.name != null ? o.name : o).toUpperCase(); });
    var iS = names.indexOf("SIZE"), iC = names.indexOf("COLOR"), iH = names.indexOf("SHELL");
    if (iS < 0 || iC < 0 || iH < 0) return out;
    var SZ = { MEDIUM: "M", LARGE: "L" }, CO = { BLACK: "BLK", "RANGER GREEN": "RG", TAN: "TAN" };
    p.variants.forEach(function (v) {
      var o = v.options || [v.option1, v.option2, v.option3];
      if (String(o[iH]).toUpperCase() !== "VENTED") return;
      var z = SZ[String(o[iS]).toUpperCase()], c = CO[String(o[iC]).toUpperCase()];
      if (z && c) out[c + "-" + z] = String(v.id);
    });
    return out;
  }
  var HELMET_HANDLE = "fast-sf-helmet";
  var helmetAvail = null;

  function helmetAvailable(color, size) {
    var id = HELMET_VARIANTS[color + "-" + size];
    if (!id) return false;
    if (!helmetAvail) return true;
    return helmetAvail[String(id)] !== false;
  }
  function helmetSizeAvailable(size) {
    return ["BLK", "TAN", "RG"].some(function (c) { return helmetAvailable(c, size); });
  }
  function helmetColorAvailable(color) {
    return ["M", "L"].some(function (z) { return helmetAvailable(color, z); });
  }
  function helmetPickBlocked() {
    return !helmetAvailable(state.color, state.size);
  }
  /* round 4: true only when the stock read is in and no vented helmet is left; the row then hides. */
  function helmetNoneLeft() {
    if (!helmetAvail) return false;
    return !["BLK", "TAN", "RG"].some(function (c) { return helmetColorAvailable(c); });
  }
  function helmetFixSelection() {
    if (!helmetAvail || helmetAvailable(state.color, state.size)) return;
    var sizes = ["M", "L"], colors = ["BLK", "TAN", "RG"], i, j;
    for (i = 0; i < sizes.length; i++) {
      if (helmetAvailable(state.color, sizes[i])) { state.size = sizes[i]; return; }
    }
    for (i = 0; i < sizes.length; i++) {
      for (j = 0; j < colors.length; j++) {
        if (helmetAvailable(colors[j], sizes[i])) { state.size = sizes[i]; state.color = colors[j]; return; }
      }
    }
  }

  /* ---------------------------------------------------------- helmet images */
  var HELMET_IMG = {
    BLK: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-blk.webp?v=1792014202",
    TAN: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-tan.webp?v=1792014222",
    RG: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-rg-nc1019.webp?v=1792014212"
  };
  var HELMET_IMG_2 = {
    BLK: "https://cdn.shopify.com/s/files/1/0676/8335/2822/files/r4-vented-helmet-detail.webp?v=1792014232",
    TAN: HELMET_IMG.TAN,
    RG: HELMET_IMG.RG
  };

  /* ------------------------------------------------------------------ state */
  var state = { fom: "1400-1550", helmet: false, size: "M", color: "BLK" };

  /* ------------------------------------------------------------- utilities  */
  function fmt(n) {
    return (
      "$" +
      n.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    );
  }
  function setClasses(el, on, onList, offList) {
    if (!el) return;
    var add = (on ? onList : offList).split(" ");
    var rm = (on ? offList : onList).split(" ");
    rm.forEach(function (c) {
      if (c) el.classList.remove(c);
    });
    add.forEach(function (c) {
      if (c) el.classList.add(c);
    });
  }

  var root = document.getElementById(ROOT_ID);
  if (!root) return;
  function $(sel) {
    return root.querySelector(sel);
  }
  function $$(sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  /* ---------------------------------------------------------------- classes */
  var PILL_ON = "border-accent bg-accent/15 text-accent";
  var PILL_OFF =
    "border-transparent bg-background/30 text-muted-foreground hover:border-accent/40 hover:text-foreground";
  var CHIP_ON = "border-accent text-accent bg-accent/10";
  var CHIP_OFF =
    "border-border text-muted-foreground hover:border-border-bright hover:text-foreground";

  /* ------------------------------------------------------------------ render */
  function kitPrice() {
    return BASE_PRICE + (FOM_UPCHARGE[state.fom] || 0);
  }
  function addOnsTotal() {
    /* NGAL-UPSELLS-2, 2026-09-19: the NGAL add on joins the same subtotal. Its
       figure comes from the variant the feed returned, never from a constant. */
    return (state.helmet ? HELMET_PRICE : 0) + (ngal && ngal.on && !ngalBlocked() ? ngalPrice() : 0);
  }
  function grandTotal() {
    return kitPrice() + addOnsTotal();
  }

  function render() {
    if (helmetNoneLeft()) state.helmet = false;
    var hrow = $("[data-np-open-dialog]");
    if (hrow) hrow.style.display = helmetNoneLeft() ? "none" : "";
    /* FOM pills */
    $$("[data-np-fom]").forEach(function (btn) {
      var f = btn.getAttribute("data-np-fom");
      if (OUT_OF_STOCK[f]) return;
      var on = f === state.fom;
      setClasses(btn, on, PILL_ON, PILL_OFF);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
      var up = btn.querySelector("span");
      if (up) setClasses(up, on, "text-accent/70", "text-muted-foreground/70");
    });

    var expl = $("[data-np-fom-explainer]");
    if (expl) expl.textContent = FOM_EXPLAINER[state.fom];

    /* prices */
    var cmp = $("[data-np-compare]");
    if (cmp) cmp.textContent = fmt(FOM_COMPARE[state.fom]);
    var tot = $("[data-np-total]");
    if (tot) tot.textContent = fmt(grandTotal());

    /* add-on subtotal chip */
    var sub = $("[data-np-addon-total]");
    if (sub) {
      if (addOnsTotal() > 0) {
        sub.style.display = "";
        sub.textContent = "+" + fmt(addOnsTotal());
      } else {
        sub.style.display = "none";
      }
    }

    /* CTA */
    var cta = $("[data-np-cta]");
    if (cta) {
      cta.textContent =
        (addOnsTotal() > 0
          ? "Get The PVS-31 PRO + Add-ons, " + fmt(grandTotal())
          : "Get The PVS-31 PRO, " + fmt(kitPrice())) + " →";
    }

    /* helmet switch */
    var sw = $("[data-np-toggle]");
    if (sw) {
      sw.setAttribute("aria-checked", state.helmet ? "true" : "false");
      setClasses(
        sw,
        state.helmet,
        "border-accent bg-accent/30",
        "border-border-bright bg-background/60 hover:border-accent"
      );
      var knob = sw.querySelector("[data-np-knob]");
      setClasses(
        knob,
        state.helmet,
        "left-[calc(100%-1.125rem)] bg-accent shadow-[0_0_8px_hsl(var(--accent)/0.7)]",
        "left-[3px] bg-muted-foreground"
      );
    }
    setClasses($("[data-np-row-title]"), state.helmet, "text-accent", "text-foreground");
    setClasses($("[data-np-row-price]"), state.helmet, "text-accent", "text-muted-foreground");

    /* size / colour chips (row + dialog). A sold out size is greyed, struck
       through and cannot be pressed. */
    $$("[data-np-size]").forEach(function (b) {
      var z = b.getAttribute("data-np-size");
      var ok = helmetSizeAvailable(z) && helmetAvailable(state.color, z);
      setClasses(b, z === state.size, CHIP_ON, CHIP_OFF);
      b.disabled = !ok;
      b.setAttribute("aria-disabled", ok ? "false" : "true");
      b.classList.toggle("opacity-50", !ok);
      b.classList.toggle("line-through", !ok);
      b.classList.toggle("cursor-not-allowed", !ok);
      b.style.display = ok ? "" : "none";
      if (!ok) b.title = "Sold out"; else b.removeAttribute("title");
    });
    $$("[data-np-color]").forEach(function (b) {
      var c = b.getAttribute("data-np-color");
      var ok = helmetColorAvailable(c);
      setClasses(b, c === state.color, CHIP_ON, CHIP_OFF);
      b.disabled = !ok;
      b.setAttribute("aria-disabled", ok ? "false" : "true");
      b.classList.toggle("opacity-50", !ok);
      b.classList.toggle("line-through", !ok);
      b.classList.toggle("cursor-not-allowed", !ok);
      b.style.display = ok ? "" : "none";
      if (!ok) b.title = "Sold out"; else b.removeAttribute("title");
    });

    /* images */
    var thumb = $("[data-np-thumb]");
    if (thumb) thumb.src = HELMET_IMG[state.color];
    var d0 = $('[data-np-dialog-img="0"]');
    if (d0) d0.src = HELMET_IMG[state.color];
    var d1 = $('[data-np-dialog-img="1"]');
    if (d1) d1.src = HELMET_IMG_2[state.color];

    /* NGAL-UPSELLS-2: the NGAL row repaints with everything else. */
    ngalRender();

    /* dialog CTA */
    var dcta = $("[data-np-dialog-cta]");
    if (dcta) {
      dcta.textContent = state.helmet
        ? "✓ ADDED, $149.95"
        : "+ ADD HELMET, $149.95";
      setClasses(
        dcta,
        state.helmet,
        "bg-accent text-accent-foreground",
        "text-accent hover:bg-accent/10"
      );
    }
  }

  /* ------------------------------------------------------------- interaction */
  $$("[data-np-fom]").forEach(function (btn) {
    var f = btn.getAttribute("data-np-fom");
    if (OUT_OF_STOCK[f]) return;
    btn.addEventListener("click", function () {
      state.fom = f;
      render();
    });
  });

  function toggleHelmet() {
    /* never turn the helmet on while the chosen size cannot be bought */
    if (!state.helmet && helmetPickBlocked()) return;
    state.helmet = !state.helmet;
    render();
  }
  var sw = $("[data-np-toggle]");
  if (sw)
    sw.addEventListener("click", function (e) {
      e.stopPropagation();
      toggleHelmet();
    });
  var dcta = $("[data-np-dialog-cta]");
  if (dcta) dcta.addEventListener("click", toggleHelmet);

  $$("[data-np-size]").forEach(function (b) {
    b.addEventListener("click", function (e) {
      e.stopPropagation();
      var z = b.getAttribute("data-np-size");
      /* a sold out size is not selectable */
      if (!helmetSizeAvailable(z) || !helmetAvailable(state.color, z)) return;
      state.size = z;
      render();
    });
  });
  $$("[data-np-color]").forEach(function (b) {
    b.addEventListener("click", function (e) {
      e.stopPropagation();
      var c = b.getAttribute("data-np-color");
      if (!helmetColorAvailable(c)) return;
      state.color = c;
      if (!helmetAvailable(c, state.size)) {
        var alt = state.size === "M" ? "L" : "M";
        if (helmetAvailable(c, alt)) state.size = alt;
      }
      render();
    });
  });

  /* ------------------------------------------------------------- add-on modal */
  var modal = $("[data-np-modal]");
  var lastFocus = null;

  function openModal() {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = "hidden";
    var close = $("[data-np-close]");
    if (close) close.focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var opener = $("[data-np-open-dialog]");
  if (opener) {
    opener.addEventListener("click", function (e) {
      if (e.target.closest("[data-np-toggle],[data-np-size],[data-np-color]")) return;
      openModal();
    });
    opener.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        openModal();
      }
    });
  }
  var closeBtn = $("[data-np-close]");
  if (closeBtn) closeBtn.addEventListener("click", closeModal);
  var overlay = $("[data-np-overlay]");
  if (overlay) overlay.addEventListener("click", closeModal);

  /* ----------------------------------------------------------- image lightbox */
  var lightbox = null;
  function openLightbox(src, alt) {
    if (!lightbox) {
      lightbox = document.createElement("div");
      lightbox.setAttribute("data-np-lightbox", "1");
      lightbox.style.cssText =
        "position:fixed;inset:0;z-index:2147482500;background:rgba(0,0,0,.85);" +
        "display:flex;align-items:center;justify-content:center;padding:24px;cursor:zoom-out";
      lightbox.innerHTML = '<img alt="" style="max-width:92vw;max-height:88vh;object-fit:contain">';
      lightbox.addEventListener("click", closeLightbox);
      root.appendChild(lightbox);
    }
    var img = lightbox.querySelector("img");
    img.src = src;
    img.alt = alt || "";
    lightbox.style.display = "flex";
    document.documentElement.style.overflow = "hidden";
  }
  function closeLightbox() {
    if (lightbox) lightbox.style.display = "none";
    document.documentElement.style.overflow = "";
  }
  $$("[data-np-zoom]").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      openLightbox(el.getAttribute("data-np-zoom"), el.getAttribute("data-np-zoom-alt"));
    });
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (lightbox && lightbox.style.display === "flex") return closeLightbox();
    if (modal && !modal.hidden) closeModal();
  });

  /* ------------------------------------------- expand / collapse comparison */
  var expBtn = $("[data-np-expand-btn]");
  var expPanel = $("[data-np-expand-panel]");
  var expFade = $("[data-np-expand-fade]");
  if (expBtn && expPanel) {
    expBtn.addEventListener("click", function () {
      var open = expPanel.classList.contains("max-h-[6000px]");
      expPanel.classList.toggle("max-h-[6000px]", !open);
      expPanel.classList.toggle("max-h-[180px]", open);
      expPanel.setAttribute("aria-hidden", open ? "true" : "false");
      expBtn.setAttribute("aria-expanded", open ? "false" : "true");
      if (expFade) expFade.style.display = open ? "" : "none";
      var chevron = expBtn.querySelector("svg");
      if (chevron) chevron.classList.toggle("rotate-180", !open);
      var label = expBtn.firstChild;
      if (label && label.nodeType === 3)
        label.nodeValue = open ? "Expand Comparison" : "Collapse";
    });
  }

  /* ------------------------------------------------- kit image ADD TO CART tap */

  var kitBtn = $("[data-np-kit-img]");
  var atc = $("[data-np-atc-overlay]");
  var atcTimer = null;
  if (kitBtn && atc) {
    kitBtn.addEventListener("click", function () {
      atc.classList.remove("opacity-0", "pointer-events-none");
      atc.classList.add("opacity-100", "pointer-events-auto");
      atc.setAttribute("aria-hidden", "false");
      atc.setAttribute("tabindex", "0");
      if (atcTimer) clearTimeout(atcTimer);
      atcTimer = setTimeout(function () {
        atc.classList.add("opacity-0", "pointer-events-none");
        atc.classList.remove("opacity-100", "pointer-events-auto");
        atc.setAttribute("aria-hidden", "true");
        atc.setAttribute("tabindex", "-1");
      }, 3000);
    });
    atc.addEventListener("click", function (e) {
      e.stopPropagation();
      if (atc.classList.contains("opacity-100")) addToCart();
    });
  }

  /* --------------------------------------------------------------- FAQ toggle */
  var faqBtns = $$("[data-np-faq-btn]");
  faqBtns.forEach(function (btn, i) {
    btn.addEventListener("click", function () {
      var panel = btn.parentNode.querySelector("[data-np-faq-panel]");
      var isOpen = panel.classList.contains("max-h-[1400px]");
      faqBtns.forEach(function (other) {
        var p = other.parentNode.querySelector("[data-np-faq-panel]");
        var plus = other.querySelector("[data-np-faq-plus]");
        p.classList.remove("max-h-[1400px]", "pb-7");
        p.classList.add("max-h-0");
        if (plus) plus.classList.remove("rotate-45");
      });
      if (!isOpen) {
        panel.classList.remove("max-h-0");
        panel.classList.add("max-h-[1400px]", "pb-7");
        var plus = btn.querySelector("[data-np-faq-plus]");
        if (plus) plus.classList.add("rotate-45");
      }
    });
  });

  /* ------------------------------------------------------------- sticky bar */
  var sticky = $("[data-np-sticky]");
  if (sticky) {
    var caps = $("#capabilities");
    var update = function () {
      if (!caps) return;
      var rect = caps.getBoundingClientRect();
      var show = rect.bottom <= 80;
      sticky.style.opacity = show ? "1" : "0";
      sticky.style.pointerEvents = show ? "auto" : "none";
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    var flashTargets = sticky.querySelectorAll("a,button");
    setInterval(function () {
      Array.prototype.forEach.call(flashTargets, function (el) {
        el.classList.add("sticky-flash-active");
        setTimeout(function () {
          el.classList.remove("sticky-flash-active");
        }, 600);
      });
    }, 5000);
  }

  /* --------------------------------------------------------------- ADD TO CART */
  function addToCart() {
    var items = [
      {
        id: KIT_VARIANTS[state.fom],
        quantity: 1,
        properties: { FOM: state.fom }
      }
    ];
    /* never send a sold out helmet variant to the cart */
    if (state.helmet && !helmetPickBlocked()) {
      items.push({
        id: HELMET_VARIANTS[state.color + "-" + state.size],
        quantity: 1,
        properties: { Color: state.color, Size: state.size }
      });
    }

    /* NGAL-UPSELLS-2: the NGAL rides in the SAME single /cart/add.js call, and
       a sold out colour can never reach it. */
    if (ngal && ngal.on && !ngalBlocked()) {
      var ngv = ngalCurrent();
      if (ngv && ngv.id) {
        items.push({
          id: String(ngv.id),
          quantity: 1,
          properties: { Color: String(ngv.option1) }
        });
      }
    }

    var busy = $$("[data-np-cta],[data-np-atc-overlay]");
    busy.forEach(function (b) {
      b.setAttribute("aria-busy", "true");
      b.style.opacity = "0.7";
    });

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
        if (window.noCartDrawerOpen) { return res.json().then(function (j) { window.noCartDrawerOpen(j); }, function () { window.noCartDrawerOpen(); }); }
        window.location.href = "/cart";
      })
      .catch(function (err) {
        /* eslint-disable-next-line no-console */
        console.error("[pvs31-lander] add to cart failed", err);
        alert("Sorry, we could not add that to your cart. Please try again.");
      })
      .then(function () {
        busy.forEach(function (b) {
          b.removeAttribute("aria-busy");
          b.style.opacity = "";
        });
      });
  }

  var cta = $("[data-np-cta]");
  if (cta) cta.addEventListener("click", addToCart);

  /* --------------------------------------------------------- lazy media kick */
  $$("video").forEach(function (v) {
    v.muted = true;
    /* The parallax video is driven by scroll. PVS-14 excludes its scrubbed
       videos from this loop the same way. Without this the video plays
       straight through instead of scrubbing. */
    if (v.getAttribute("poster") && v.getAttribute("poster").indexOf("parallax-portrait") > -1) return;
    if (v.autoplay || v.hasAttribute("data-np-autoplay")) {
      v.muted = true; v.playsInline = true; /* NO-VIDEO-INLINE-1014 */
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
  });

  /* --------------------------------------------- video lifecycle (iOS)
     PVS-14 has this and PVS-31 never did. iOS Safari caps how many videos can
     decode at once. This page autoplays four looping videos and never stops
     them, so by the time the parallax tries to seek there is no decoder left
     and it sits on the entry frame. Desktop has no such cap, which is why it
     only ever failed on the phone.

     Two rules: pause anything off screen, and while the parallax stage is on
     screen pause everything else outright so the scrub owns the decoder.   */
  (function () {
    var scrub = $('video[poster*="parallax-portrait"]');
    var all = $$("video");
    if (!all.length || !("IntersectionObserver" in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (v === scrub) return;                 /* driven by scroll, never by us */
        if (e.isIntersecting) {
          if (v.paused && (v.autoplay || v.hasAttribute("data-np-autoplay"))) {
            v.muted = true; v.playsInline = true; /* NO-VIDEO-INLINE-1014 */
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          }
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.15 });
    all.forEach(function (v) { if (v !== scrub) io.observe(v); });

    /* Hand the decoder to the parallax while its track is anywhere near view. */
    if (scrub) {
      var stage = scrub.parentElement;
      var track = stage && stage.parentElement;
      if (track) {
        var guard = new IntersectionObserver(function (entries) {
          var near = entries[0] && entries[0].isIntersecting;
          all.forEach(function (v) {
            if (v === scrub) return;
            if (near) { if (!v.paused) v.pause(); }
          });
        }, { rootMargin: "200% 0px" });
        guard.observe(track);
      }
    }
  })();

  /* ------------------------------------------------- mobile parallax scrub
     Ported from bindPvs31Parallax in pvs14-lander.js, which is the build that
     works on iOS. Deliberately does NOT touch preload and never calls load():
     both reset the element mid-activation on iOS Safari, which leaves the
     poster frame frozen while scroll still feels like it is pinning.        */
  (function () {
    var video = $('video[poster*="parallax-portrait"]');
    if (!video) return;
    var stage = video.parentElement;
    var wrapper = stage && stage.parentElement;      /* the h-[240vh] track */
    if (!wrapper) return;

    /* iOS parks a preload="metadata" video at readyState 1, metadata only, no
       frame data. Seeks against it are accepted and never painted, which looks
       exactly like a frozen parallax. autoplay plus preload="auto" is what
       drags it up to readyState 4. This is how the PVS-14 build gets there.
       The generic autoplay loop above already skips this video, so setting
       autoplay here cannot make it play through. */
    video.muted = true;            video.setAttribute("muted", "");
    video.playsInline = true;      video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "true");
    video.preload = "auto";        video.setAttribute("preload", "auto");
    video.autoplay = true;         video.setAttribute("autoplay", "");
    video.loop = false;

    var ENTRY = 0.42;
    var raf = null, targetTime = ENTRY, ready = false, settling = false;

    function settle() {
      /* Let it actually buffer, then park it on the entry frame. Pausing the
         instant play() resolves can stop the buffering we just asked for. */
      if (settling) return;
      settling = true;
      var tries = 0;
      (function waitForData() {
        tries++;
        if (video.readyState >= 3 || tries > 25) {
          try { video.pause(); video.currentTime = ENTRY; } catch (e) {}
          ready = true;
          onScroll();
          return;
        }
        setTimeout(waitForData, 120);
      })();
    }

    function kick() {
      if (ready || settling) return;
      if (!video.duration || isNaN(video.duration)) return;   /* need metadata */
      video.muted = true; video.playsInline = true; /* NO-VIDEO-INLINE-1014 */
      var p = video.play();
      if (p && p.then) p.then(settle).catch(function () { settle(); });
      else settle();
    }

    /* Fire on anything that signals progress, not just loadeddata, because on
       iOS loadeddata never arrives while the element is stuck at readyState 1. */
    ["loadedmetadata", "loadeddata", "canplay", "canplaythrough", "progress",
     "durationchange", "suspend"].forEach(function (ev) {
      video.addEventListener(ev, kick);
    });
    if (video.readyState >= 1) kick();
    /* Belt and braces: a real gesture always unlocks media on iOS. */
    ["touchstart", "pointerdown"].forEach(function (ev) {
      window.addEventListener(ev, kick, { passive: true });
    });
    setTimeout(kick, 400);
    setTimeout(kick, 1500);

    function tick() {
      raf = null;
      var d = video.duration;
      if (!d || isNaN(d)) return;
      try { video.currentTime = Math.max(0, Math.min(d - 0.001, targetTime)); } catch (e) {}
    }
    function onScroll() {
      if (!ready) { kick(); return; }
      var dist = wrapper.offsetHeight - window.innerHeight;
      if (dist <= 0) return;                          /* desktop: wrapper hidden */
      var progress = Math.max(0, Math.min(1, -wrapper.getBoundingClientRect().top / dist));
      targetTime = ENTRY + progress * Math.max(0, (video.duration || 0) - ENTRY);
      if (raf == null) raf = requestAnimationFrame(tick);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    /* Once we own it, nothing else gets to play it. */
    video.addEventListener("play", function () {
      if (ready) { try { video.pause(); } catch (e) {} }
    });
  })();


  /* ========================================================================
     NGAL ADD ON ROW (lane NGAL-UPSELLS-2, 2026-09-19)
     Bon: "add the NGAL onto the PVS14 and PVS31 pages as well."

     WHY IT IS BUILT HERE AND NOT IN THE MARKUP. snippets/pvs31-lander.liquid is
     a raw HTML dump with no Liquid in it at all, so a row written there could
     neither read a price from the variant nor hide itself outside the US. This
     block therefore builds the row from the product feed, in the same shape as
     the helmet row it sits under, and joins the SAME single /cart/add.js call.

     IT FAILS CLOSED. /products/ngal-ir-laser-illuminator.js answers 404 outside
     the United States, because the NGAL sits in the SNAPL delivery profile whose
     only zone is the US and it is excluded from the other markets' catalogs.
     A 404, a network failure or a malformed answer all leave the row UNBUILT, so
     a visitor who cannot buy it never sees it. That is the opposite default from
     the helmet availability read above, and deliberately so: there an unknown
     answer leaves every size selectable because a false sold out costs a real
     sale, whereas here an unknown answer means we do not know the shopper may
     buy it at all.

     A SOLD OUT COLOUR GREYS, THE ROW STAYS (rulebook section 1b). A colour whose
     variant is unavailable is dimmed, struck through, unpressable and titled
     Sold out, exactly as the helmet size chips are. The row is never removed for
     a stock out: disabling an add on because stock ran out is the failure, not
     the remedy.

     THE PRICE IS NEVER TYPED. Every figure comes from the variant the feed
     returned. There is no NGAL price constant in this file on purpose.
     ==================================================================== */
  /* `var` hoists, so this object exists as undefined from the top of the IIFE
     until this line runs. Everything that reads it therefore guards with
     `ngal &&`, because render() is called from several places above this point
     and an early paint must never throw. */
  var ngal = { avail: false, variants: [], color: null, on: false, row: null };

  function ngalMoney(cents) {
    var n = Number(cents);
    if (!n) return 0;
    return n > 500 ? n / 100 : n;
  }
  function ngalCurrent() {
    if (!ngal || !ngal.variants) return null;
    for (var i = 0; i < ngal.variants.length; i++) {
      if (String(ngal.variants[i].option1) === String(ngal.color)) return ngal.variants[i];
    }
    return null;
  }
  function ngalPrice() {
    var v = ngalCurrent();
    return v ? ngalMoney(v.price) : 0;
  }
  function ngalBlocked() {
    var v = ngalCurrent();
    return !(v && v.available);
  }
  /* Never leave the shopper holding a colour that cannot be bought. */
  function ngalFixSelection() {
    if (!ngal || !ngalBlocked()) return;
    for (var i = 0; i < ngal.variants.length; i++) {
      if (ngal.variants[i].available) { ngal.color = ngal.variants[i].option1; return; }
    }
  }

  function ngalBuildRow(product) {
    var host = $("[data-np-addon-total]");
    host = host ? host.parentNode : null;
    host = host ? host.parentNode : null;   // the COMPLETE YOUR SETUP container
    if (!host) return null;

    var row = document.createElement("div");
    row.className = "flex items-start gap-3 py-3 border-t border-border/40 first:border-t-0 transition-colors -mx-2 px-2 rounded-sm";
    row.setAttribute("data-np-ngal-row", "1");

    var sw = document.createElement("button");
    sw.type = "button";
    sw.setAttribute("role", "switch");
    sw.setAttribute("aria-checked", "false");
    sw.setAttribute("aria-label", "Add NGAL IR/VIS laser");
    sw.setAttribute("data-np-ngal-toggle", "1");
    sw.className = "mt-0.5 relative shrink-0 w-10 h-5 rounded-full border transition-colors border-border-bright bg-background/60 hover:border-accent";
    var knob = document.createElement("span");
    knob.setAttribute("data-np-ngal-knob", "1");
    knob.className = "absolute top-1/2 -translate-y-1/2 w-3.5 h-3.5 rounded-full transition-all left-[3px] bg-muted-foreground";
    sw.appendChild(knob);
    row.appendChild(sw);

    var imgWrap = document.createElement("div");
    imgWrap.className = "shrink-0 w-12 h-12 sm:w-14 sm:h-14 aspect-square flex items-center justify-center overflow-hidden";
    var img = document.createElement("img");
    img.className = "w-full h-full object-contain";
    img.setAttribute("data-np-ngal-thumb", "1");
    img.setAttribute("loading", "lazy");
    img.alt = product.title || "NGAL IR/VIS laser";
    if (product.featured_image) img.src = product.featured_image;
    imgWrap.appendChild(img);
    row.appendChild(imgWrap);

    var textCol = document.createElement("div");
    textCol.className = "flex-1 min-w-0 text-left";
    var head = document.createElement("div");
    head.className = "flex items-baseline justify-between gap-2 flex-wrap";
    var title = document.createElement("span");
    title.className = "mono text-[12px] tracking-[0.1em] uppercase break-words min-w-0 text-foreground";
    title.setAttribute("data-np-ngal-title", "1");
    title.textContent = "NGAL IR/VIS LASER";
    var price = document.createElement("span");
    price.className = "mono text-[12px] tracking-[0.06em] shrink-0 text-muted-foreground";
    price.setAttribute("data-np-ngal-price", "1");
    head.appendChild(title);
    head.appendChild(price);
    textCol.appendChild(head);
    var sub = document.createElement("p");
    sub.className = "text-[12px] leading-[1.4] text-muted-foreground mt-0.5";
    sub.textContent = "Rail mounted and live fire recoil rated. Infrared and visible aiming beams.";
    textCol.appendChild(sub);

    var opts = document.createElement("div");
    opts.className = "mt-2 flex flex-wrap items-center gap-1.5";
    opts.setAttribute("data-np-ngal-opts", "1");
    ngal.variants.forEach(function (v) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = CHIP_OFF;
      b.setAttribute("data-np-ngal-color", String(v.option1));
      b.textContent = String(v.option1);
      b.addEventListener("click", function (e) {
        e.stopPropagation();
        if (!v.available) return;
        ngal.color = String(v.option1);
        render();
      });
      opts.appendChild(b);
    });
    textCol.appendChild(opts);
    row.appendChild(textCol);

    sw.addEventListener("click", function (e) {
      e.stopPropagation();
      /* never turn it on while the chosen colour cannot be bought */
      if (!ngal.on && ngalBlocked()) return;
      ngal.on = !ngal.on;
      render();
    });

    host.appendChild(row);
    return row;
  }

  /* Painted on every render, next to the helmet row's own repaint. */
  function ngalRender() {
    if (!ngal || !ngal.row) return;
    var sw = $("[data-np-ngal-toggle]");
    if (sw) {
      sw.setAttribute("aria-checked", ngal.on ? "true" : "false");
      setClasses(sw, ngal.on,
        "border-accent bg-accent/30",
        "border-border-bright bg-background/60 hover:border-accent");
      var knob = sw.querySelector("[data-np-ngal-knob]");
      setClasses(knob, ngal.on,
        "left-[calc(100%-1.125rem)] bg-accent shadow-[0_0_8px_hsl(var(--accent)/0.7)]",
        "left-[3px] bg-muted-foreground");
    }
    setClasses($("[data-np-ngal-title]"), ngal.on, "text-accent", "text-foreground");
    setClasses($("[data-np-ngal-price]"), ngal.on, "text-accent", "text-muted-foreground");
    var pEl = $("[data-np-ngal-price]");
    if (pEl) pEl.textContent = "+" + fmt(ngalPrice());
    var tEl = $("[data-np-ngal-thumb]");
    var cv = ngalCurrent();
    if (tEl && cv && cv.featured_image && cv.featured_image.src) tEl.src = cv.featured_image.src;
    $$("[data-np-ngal-color]").forEach(function (b) {
      var c = b.getAttribute("data-np-ngal-color");
      var v = null;
      for (var i = 0; i < ngal.variants.length; i++) {
        if (String(ngal.variants[i].option1) === c) { v = ngal.variants[i]; break; }
      }
      var ok = !!(v && v.available);
      setClasses(b, c === ngal.color, CHIP_ON, CHIP_OFF);
      b.disabled = !ok;
      b.setAttribute("aria-disabled", ok ? "false" : "true");
      b.classList.toggle("opacity-50", !ok);
      b.classList.toggle("line-through", !ok);
      b.classList.toggle("cursor-not-allowed", !ok);
      if (!ok) b.title = "Sold out"; else b.removeAttribute("title");
    });
  }

  /* Read the NGAL once. A 404 (any shopper outside the US) leaves the row
     unbuilt and nothing on the page changes at all. */
  (function loadNgal() {
    try {
      fetch("/products/ngal-ir-laser-illuminator.js", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.variants || !j.variants.length) return;
          ngal.variants = j.variants.filter(function (v) { return v && v.id; });
          if (!ngal.variants.length) return;
          ngal.color = String(ngal.variants[0].option1);
          ngalFixSelection();
          ngal.avail = true;
          ngal.row = ngalBuildRow(j);
          if (!ngal.row) { ngal.avail = false; return; }
          render();
        })
        .catch(function () {});
    } catch (e) {}
  }());

  render();

  /* Read helmet availability once, then repaint. An unknown answer leaves every
     size selectable, because a false sold out costs a real sale. */
  (function loadHelmetAvailability() {
    try {
      fetch("/products/" + HELMET_HANDLE + ".js", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.variants) return;
          var map = {};
          j.variants.forEach(function (v) { map[String(v.id)] = !!v.available; });
          var vm = noVented(j); Object.keys(vm).forEach(function (k) { HELMET_VARIANTS[k] = vm[k]; });
          helmetAvail = map;
          helmetFixSelection();
          if (state.helmet && helmetPickBlocked()) state.helmet = false;
          render();
        })
        .catch(function () {});
    } catch (e) {}
  }());
})();